<!-- size is for displaying single/double grids, in future we will provide support of more than 2 grids in a row same as radio group -->
<div class="checkbox-group">
  <ng-container *ngFor="let option of options">
    <ion-item
      *ngIf="checkboxStyle === 'default'"
      lines="none"
      [ngClass]="'mb-checkbox'"
    >
      <ion-checkbox
        [(ngModel)]="option.isChecked"
        (ionChange)="updateOptions(option)"
        [attr.aria-label]="option.aria || option.name.replace('-', ' to ')"
        labelPlacement="end"
        justify="start"
      >
        <span class="checkbox-content ion-text-wrap">
          {{ option.name }}
        </span>
      </ion-checkbox>
    </ion-item>
    <ion-item
      *ngIf="checkboxStyle !== 'default'"
      lines="none"
      [ngClass]="checkboxStyle === 'oval' ? 'oval-checkbox' : 'square-checkbox'"
    >
      <ion-checkbox
        [(ngModel)]="option.isChecked"
        (ionChange)="updateOptions(option)"
        [attr.aria-label]="option.aria || option.name.replace('-', ' to ')"
      >
        <span class="checkbox-content ion-text-wrap">
          <!-- checkmark icon to be applied when checkboxstyle is not 'default' -->
          <ng-container>
            <ion-icon
              name="checkmark"
              class="checked-icon"
            >
            </ion-icon>
            <!-- custom icon to be applied when checkboxstyle is 'square' and icon is available -->
            <ion-icon
              [name]="option.icon"
              *ngIf="checkboxStyle === 'square' && option?.icon"
              class="options-icon"
            >
            </ion-icon>
          </ng-container>
          {{ option.name }}
        </span>
      </ion-checkbox>
    </ion-item>
  </ng-container>
</div>
